import { Avatar, AvatarGroup, Size, useCustomEvent } from '@fold-dev/core'
import { useEffect, useState } from 'react'
import { useTeamUsers } from '../../hooks/api.hooks'
import { PresenceAvatar } from './presence-avatar'

export const TeamUserPreview = ({ teamId, workspaceId, size = 'md' as Size }) => {
    const [teamUsers, setTeamUsers] = useState([])
    const teamUsersAPI = useTeamUsers()
    const [more, setMore] = useState(0)

    const fetchData = async () => {
        const teamUsers = await teamUsersAPI.getPreview(workspaceId, teamId)
        setTeamUsers(teamUsers)
        setMore(!!teamUsers.length ? teamUsers[0].total_team_users - teamUsers.length : 0)
    }

    const handleRefreshPreviewEvent = ({ detail }) => {
        if (detail.id == teamId) fetchData()
    }

    useCustomEvent('team:refresh-preview', handleRefreshPreviewEvent)

    useEffect(() => {
        if (teamId) fetchData()
    }, [teamId])

    return (
        <AvatarGroup
            invert
            p={2}
            radius="var(--f-radius-full)"
            style={{
                'offsetWidth': 2,
                '--f-image-background-color': 'var(--f-color-surface-stronger)',
                '--f-avatar-background-color': 'var(--f-color-surface-stronger)',
            }}>
            {teamUsers.map((teamUser: any, index) => (
                <PresenceAvatar
                    noPresence
                    key={teamUser.image + index}
                    name={teamUser.name}
                    size={size}
                    src={teamUser.image}
                    border="2px solid var(--f-color-surface)"
                />
            ))}
            {!!more && (
                <PresenceAvatar
                    noPresence
                    border="2px solid var(--f-color-surface)"
                    size={size}>
                    <span
                        style={{ fontWeight: 'normal' }}
                        className={'f-text ' + size}>
                        +{more}
                    </span>
                </PresenceAvatar>
            )}
        </AvatarGroup>
    )
}
